module.exports = __webpack_public_path__ + "img/penilaian-buku-non-teks.39d6d448.jpeg";